import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = process.env.NODE_ENV !== 'production' ?
    'https://api-dev.vetincloud.com/api/' :
    'https://api.vetincloud.com/api/'

// Define a service using a base URL and expected endpoints
export const vetincloudApi = createApi({
    reducerPath: 'vic-api',
    baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
    endpoints: (builder) => ({
        getAccountByToken: builder.query<any, string>({
            query: (token) => `customer-area/account/${token}`,
        }),
        saveCustomer: builder.mutation<any, any>({
            query: (data) => ({
                url: `customer-area/customer`,
                method: 'POST',
                body: data
            })
        })
    }),
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetAccountByTokenQuery, useSaveCustomerMutation } = vetincloudApi

export default vetincloudApi